import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  CollectionType,
  StatsChartType,
} from '@pages/statistics-page/constants';
import { StatsChartConfiguration } from '@pages/statistics-page/interfaces';
import { StatisticsDataService } from '@pages/statistics-page/services/statistics-data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-triggers',
  templateUrl: './triggers.component.html',
  styleUrls: ['./triggers.component.scss'],
  providers: [
    StatisticsDataService,
    { provide: 'chartGroupType', useValue: CollectionType.Triggers },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TriggersComponent implements OnInit {
  private dataService = inject(StatisticsDataService);

  triggersChartData$: Subject<Map<StatsChartType, StatsChartConfiguration>>;

  chartType: typeof StatsChartType = StatsChartType;

  ngOnInit(): void {
    this.triggersChartData$ = this.dataService.chartData$;
  }
}
